import * as React from "react";

import { cn } from "@/lib/utils";

/*
 * Replaces src/components/page-header/index.js (MUI Grid + Typography +
 * styled Button). `actions` is the rendering slot for whatever CTA the
 * page wants — kept as a children slot instead of buttonTitle/onClick
 * props so callers can drop in any shadcn Button (or several) without
 * the wrapper inventing a button API.
 */

// HTMLAttributes has its own (string) `title`; omit it so the prop can
// carry React nodes (icons + label, etc.).
interface PageHeaderProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
}

export function PageHeader({
  title,
  description,
  actions,
  className,
  ...props
}: PageHeaderProps) {
  return (
    <header
      className={cn(
        "flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between",
        className,
      )}
      {...props}
    >
      <div className="space-y-1">
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        {description ? (
          <p className="text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {actions}
        </div>
      ) : null}
    </header>
  );
}
